export default __webpack_public_path__ + "static/media/gallery154_2.16b565d7.png";